import { services } from '@orionprotocol/sdk';
import { z } from 'zod';

const {
  getPoolResponseSchema,
  listNFTOrderResponseSchema,
  listPoolV3ResponseSchema,
} = services.indexer.schemas;

export type PoolV3Info = z.infer<typeof getPoolResponseSchema>['result'];

export type PoolResponseInfo = z.infer<typeof getPoolResponseSchema>['info'];

type ValueOf<T> = T[keyof T];

export type PoolV3SpecificInfo = NonNullable<ValueOf<PoolV3Info['pools']>>;

export type PoolV3Position = z.infer<
  typeof listNFTOrderResponseSchema
>['result'][number];

export type PoolV3 = z.infer<typeof listPoolV3ResponseSchema>['result'][number];

export type Pool = {
  name: string;
  totalLiquidityInDollars?: number;
  reserves: Record<string, string>;
  price: number;
  staking: {
    totalStakedAmountInDollars?: number;
    stakingRewardRatePerWeek?: number; // in ORN per week
    stakingAPR?: number; // in percents
  };
  governance: {
    myVoted: number;
    totalVoted: number;
    weight?: number;
  };
};
